import React from "react";
import { fmtDate, labelize } from "@/lib/constants";
import { Clock } from "@phosphor-icons/react";

/** Append-only event timeline card. */
export default function LeadTimeline({ events }) {
  return (
    <div className="brut-card mt-4 p-5">
      <div className="font-chivo font-bold uppercase tracking-tight mb-4 flex items-center gap-2">
        <Clock size={16} weight="bold" /> Event timeline (append-only)
      </div>
      <ol className="relative border-l-2 border-black ml-3">
        {events.map((e) => (
          <li key={e.id} className="ml-4 mb-4" data-testid={`event-${e.event_type}`}>
            <div className="absolute w-3 h-3 bg-black border border-black -left-[7px] mt-1.5" />
            <div className="text-[11px] font-mono text-zinc-500">{fmtDate(e.created_at)}</div>
            <div className="font-mono text-sm">{labelize(e.event_type)}</div>
            <div className="text-xs text-zinc-700">
              {e.actor_name ? `by ${e.actor_name}` : "automated"}
              {e.reason ? ` · ${e.reason}` : ""}
              {e.notes ? ` · ${e.notes}` : ""}
            </div>
            {(e.previous_value !== undefined && e.previous_value !== null) && (
              <details className="text-[11px] font-mono mt-1">
                <summary className="cursor-pointer">before → after</summary>
                <div className="mt-1 grid grid-cols-2 gap-2">
                  <pre className="bg-zinc-100 border border-zinc-300 p-2 whitespace-pre-wrap">
                    {JSON.stringify(e.previous_value, null, 2)}
                  </pre>
                  <pre className="bg-zinc-100 border border-zinc-300 p-2 whitespace-pre-wrap">
                    {JSON.stringify(e.new_value, null, 2)}
                  </pre>
                </div>
              </details>
            )}
          </li>
        ))}
        {!events.length && <li className="ml-4 label-mono">No events yet</li>}
      </ol>
    </div>
  );
}
